import SarthakImage from "../assets/sarthak2.png";
import SarthakImagePassport from "../assets/SarthakPassport.png";
import { getYearsOfExperience } from "../utils/experience";
import { TypeAnimation } from "react-type-animation";
import { CTButton } from "../components/Common/CTButton";
import { useNavigate } from "react-router-dom";
import { TiArrowRightThick } from "react-icons/ti";
import { useEffect, useState } from "react";

export const Home = ({ currentMode }) => {
  // console.log("Inside Home",currentMode);
  const navigate = useNavigate();

  const [imgSource, setImgSource] = useState("");

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    scrollToTop();
  }, []);

  useEffect(() => {
    const updateImgSource = () => {
      if (window.innerWidth < 1024) {
        setImgSource(SarthakImagePassport);
      } else {
        setImgSource(SarthakImage);
      }
    };

    updateImgSource();

    window.addEventListener("resize", updateImgSource);

    return () => {
      window.removeEventListener("resize", updateImgSource);
    };
  }, []);

  return (
    <div className="home-effect flex lg:flex-row flex-col items-center justify-center w-screen lg:min-h-[calc(100vh-env(safe-area-inset-bottom))] lg:mt-0  lg:mb-0 min-h-[calc(100% + 15%)] mt-[6%] mb-[15%] transition-all duration-200">
      <div className="w-[80%] md:w-[70%] lg:w-[50%] mt-6 lg:mt-0 border-richblack-100">
        <img
          src={imgSource}
          alt="Sarthak"
          className="w-[65%] lg:rounded-3xl lg:my-0 mb-6 rounded-full
          mx-auto text-center shadow-2xl shadow-black"
        />
      </div>
      <div className="w-[80%] lg:w-[60%] flex flex-col justify-center items-center lg:items-start gap-y-4">
        <p className="text-orange pt-4 text-xl sm:text-2xl md:text-4xl lg:text-[42px] font-bold">
          - I'M SARTHAK KHETARPAL
        </p>

        <div
          className={`${
            currentMode === "dark" ? "text-white" : "text-richblack-500"
          } text-2xl sm:text-3xl md:text-5xl font-bold`}
        >
          <TypeAnimation
            sequence={[
              "Senior Software Engineer",
              2000,
              "Full Stack Developer",
              2000,
              "Team Lead & Mentor",
              2000,
            ]}
            wrapper="span"
            speed={10}
            repeat={Infinity}
          />
        </div>

        <p
          className={`${
            currentMode === "dark" ? "text-white" : "text-richblack-500"
          } w-[90%] lg:w-[75%] text-xs md:text-sm leading-6 xl:text-md py-[25px] xl:py-[35px]`}
        >
          I’m a software engineer at heart — I love turning ideas into products
          people actually use. Over <b>{getYearsOfExperience()}+ years</b> of
          building software — from full-stack web platforms to system-level
          applications — the thrill of shipping something new hasn’t faded one
          bit.
          <br />
          <br />
          What keeps me hooked is how fast technology moves. A new framework, an
          AI-powered workflow, a smarter way to architect a system — I’m always
          experimenting, learning, and upgrading myself, one project at a time.
          <br />
          <br />
          Let’s create something great together!
        </p>

        <CTButton
          text="MORE ABOUT ME"
          icon={<TiArrowRightThick />}
          clickHandler={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            navigate("/About");
          }}
          currentMode={currentMode}
          className="mb-12"
        />
      </div>
    </div>
  );
};
